<template>
  <FrameResize ref="wrapper" :position="position" :class="{'disabled':disableCropResize}">
    <SizeDetail class="center-hv" v-if="is_drag">
      W: {{ position.width }}, H: {{ position.height }}</SizeDetail
    >
    <div v-if="!isFixRatio" class="resize n" ref="n" @mouseover="initMouseOver('n')"></div>
    <div class="resize nw" ref="nw" @mouseover="initMouseOver('nw')"></div>
    <div class="resize ne" ref="ne" @mouseover="initMouseOver('ne')"></div>
    <div v-if="!isFixRatio" class="resize e" ref="e" @mouseover="initMouseOver('e')"></div>
    <div v-if="!isFixRatio" class="resize w" ref="w" @mouseover="initMouseOver('w')"></div>
    <div v-if="!isFixRatio" class="resize s" ref="s" @mouseover="initMouseOver('s')"></div>
    <div class="resize sw" ref="sw" @mouseover="initMouseOver('sw')"></div>
    <div class="resize se" ref="se" @mouseover="initMouseOver('se')"></div>
  </FrameResize>
</template>

<script>
import { FrameResize, SizeDetail } from "./ImageCrop.styled";
import { mapGetters } from "vuex";

export default {
  props: ["component", "position", "callback", "translate", "isDrag", "onDrag", "isFixRatio","disableCropResize"],
  data() {
    return {
      ratio: 1,
      resizeDirection: undefined,
      is_drag: this.isDrag
    };
  },
  watch: {
    mouseup() {
      this.closeDragElement();
    },
    isDrag(newVal, oldVal)
    {
      if(newVal !== oldVal) this.is_drag = newVal;
    },
    is_drag(newVal, oldVal)
    {
      if(newVal !== oldVal) this.$emit('onDrag', newVal);
    }
  },
  components: {
    FrameResize,
    SizeDetail,
  },
  computed: {
    ...mapGetters({
      mouseup: "designIframe/windowEvent/mouseup",
    }),
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    initMouseOver(ref) {
      if(!this.disableCropResize){
        this.dragElement(ref);
      }
      return false
    },
    dragElement(ref) {
      if (this.$refs[ref]) {
        this.resizeDirection = ref;
        this.$refs[ref].onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      e = e || window.event;
      this.is_drag = true;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;

      const { width, height } =
        this.$refs["wrapper"].$el.getBoundingClientRect();

      this.ratio = width / height;
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      let diffval = 0;
      let newWidth = 0;
      const { width, height } =
        this.$refs["wrapper"].$el.getBoundingClientRect();
      switch (this.resizeDirection) {
        case "n":
          this.callback({
            height: parseInt(height + this.pos2),
            width,
            difftop: this.pos2,
          });
          break;
        case "w":
          this.callback({
            height,
            width: parseInt(width + this.pos1),
            diffleft: this.pos1,
          });
          break;
        case "e":
          this.callback({
            height,
            width: parseInt(width - this.pos1),
          });
          break;

        case "s":
          this.callback({ height: parseInt(height - this.pos2), width });

          break;
        case "se":
          diffval = this.pos2 + this.pos1;
          newWidth = parseInt(width - diffval);
          this.callback({
            width: newWidth,
            height: parseInt(newWidth / this.ratio),
          });
          break;
        case "nw":
          diffval = this.pos2 + this.pos1;
          newWidth = parseInt(width + diffval);
          this.callback({
            width: newWidth,
            height: parseInt(height + diffval),
            difftop: diffval,
            diffleft: diffval,
          });
          break;
        case "ne":
          diffval = this.pos2 - this.pos1;
          newWidth = parseInt(width + diffval);
          this.callback({
            width: newWidth,
            height: parseInt(height + diffval),
            difftop: diffval,
          });
          break;
        case "sw":
          diffval = this.pos2 - this.pos1;
          newWidth = parseInt(width - diffval);
          this.callback({
            width: newWidth,
            height: parseInt(newWidth / this.ratio),
            diffleft: -diffval,
          });
          break;
        default:
          break;
      }
    },

    closeDragElement() {
      // stop moving when mouse button is released:
      this.is_drag = false;
      document.onmouseup = null;
      document.onmousemove = null;
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
};
</script>

<style>
</style>